var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{staticClass:"polyline",style:(_vm.polylineStyle),attrs:{"d":_vm.polylinePath}}),(_vm.bullet)?_c('g',{staticClass:"bullets"},[_c('defs',[_c('path',{style:({
          strokeWidth: 1,
          fill: _vm.dominant ? 'inherit' : 'none',
          stroke: _vm.dominant ? 'none' : 'inherit'
        }),attrs:{"id":_vm.pointIndicatorID,"d":_vm.bulletPath}})]),_vm._l((_vm.points),function(point,pIdx){return _c('use',{key:("point_" + pIdx),attrs:{"href":("#" + _vm.pointIndicatorID),"x":point[0],"y":point[1]}})})],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }